class LanguagePopup extends HTMLElement {
    constructor() {
        super();
		this.elements = {
			input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
			button: this.querySelector('button'),
			panel: this.querySelector('ul'),
		};

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
		
		if(document.getElementsByClassName('disclosure__button')[0]){
          document.getElementsByClassName('disclosure__button')[0].addEventListener('click',this.setOpenPopup.bind(this))
        }
        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
		
		this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));

        this.querySelector('[data-close-language-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );
    }

    setOpenPopup() {
		setTimeout(function() {
			document.body.classList.add('language-show');
		}, this.timeToShow);
    }
    

    setClosePopup() {
        document.body.classList.remove('language-show');
        setTimeout(() => {
            document.body.classList.remove('show-language-image');
        }, 700)
    }
    
	onItemClick(event) {
		event.preventDefault();
		this.elements.input.value = event.currentTarget.dataset.value;
		this.querySelector('form')?.submit();
	}

    onBodyClickEvent(event){
        if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-language-popup]').length === 0) && document.querySelector('body').classList.contains('language-show')){
            this.setClosePopup();
        }
    }
}

customElements.define('elspet-language-popup', LanguagePopup);